import { Component } from 'react'
import { formatTableCurrency } from 'helpers/tableHelpers'
import { formatUSDate } from 'helpers/dateTimeHelpers'
import Table2, { TableContextType, TableContext } from 'components/molecules/tables/Table2'
import { CreditAccount } from 'interfaces/credit'
import AccountBadge, { AccountBadgeProps } from 'components/features/pfm/AccountBadge/AccountBadge'
import AccountTooltip from 'components/features/pfm/AccountTooltip/AccountTooltip'
import withContext from 'hocs/withContext/withContext'

export type CreditAccountsDetailsRowProps = {
  table: TableContextType
  row: CreditAccount
}

class CreditAccountsDetailsRow extends Component<CreditAccountsDetailsRowProps, {}> {
  render () {
    const { row } = this.props
    const { category, condition, balance, pay_status, opened_at, credit_limit } = row
    const rowKey = this.props.table.getRowKey(row)

    const accountBadgeProps: AccountBadgeProps = {
      name: row.name,
      cardNumber: row.number,
      updatedAt: row.updated_at,
      tooltipChild: (
        <AccountTooltip type='creditscore' account={ row } />
      ),
    }

    return (
      <Table2.Row key={ rowKey }>
        <Table2.Cell rowKey={ rowKey } name='account_type'>
          { category.value }
        </Table2.Cell>

        <Table2.Cell rowKey={ rowKey } name='account_name'>
          <AccountBadge { ...accountBadgeProps } />
        </Table2.Cell>

        <Table2.Cell rowKey={ rowKey } name='condition'>
          { condition }
        </Table2.Cell>

        <Table2.Cell rowKey={ rowKey } name='balance'>
          { formatTableCurrency(balance) }
        </Table2.Cell>

        <Table2.Cell rowKey={ rowKey } name='pay_status'>
          { pay_status }
        </Table2.Cell>

        <Table2.Cell rowKey={ rowKey } name='opened_at'>
          { formatUSDate(opened_at) }
        </Table2.Cell>

        <Table2.Cell rowKey={ rowKey } name='credit_limit'>
          { formatTableCurrency(credit_limit) }
        </Table2.Cell>
      </Table2.Row>
    )
  }
}

export default withContext(TableContext, 'table')(CreditAccountsDetailsRow)
